var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarBayrun4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1195,
    height: 496,
    viewBox: "0 0 1195 496",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.427 443.61C128.987 444.64 139.217 445.22 139.217 445.22L139.317 445.12L140.727 445.22C145.067 445.6 149.767 446.11 154.107 446.33C168.467 447.28 183.087 448.06 197.477 448.34C213.087 448.83 228.957 449.04 244.567 449.04C251.187 449.08 258.277 448.75 264.897 448.54C267.507 448.31 271.907 446.86 274.277 446.09L274.757 451.25H274.767C274.047 451.34 273.327 451.5 272.647 451.75C272.187 451.9 271.357 452.18 270.927 452.66C270.577 453.07 270.627 453.37 270.627 453.37C270.937 457.88 272.287 463.94 273.347 468.36C273.727 469.93 274.117 471.5 274.537 473.06C274.917 474.45 275.307 475.83 275.747 477.2C276.117 478.33 276.477 479.51 277.067 480.54C279.247 484.36 282.377 490.36 285.217 493.52C285.217 493.52 285.797 494.32 286.927 494.42L288.837 494.52C289.447 494.52 293.497 490.75 293.857 490.11C294.067 489.72 294.137 489.31 293.877 488.88H293.977L294.687 489.28H294.787L298.257 487.69C298.257 487.69 298.297 487.71 298.307 487.72C299.067 487.42 298.747 486.49 298.807 485.85C297.127 477.79 293.477 464.59 291.487 456.47C291.467 456.4 291.447 456.34 291.427 456.27L290.487 453.45C290.397 453.19 290.237 452.96 290.017 452.8L287.917 451.24C287.737 451.1 287.527 450.99 287.317 450.92L285.937 450.41C285.467 448.76 285.317 447.24 285.567 445.9H286.677L369.957 445.72C414.007 446.58 504.967 447.46 504.967 447.46C582.117 448.05 670.277 448.42 760.157 448.35L796.787 448.48C796.787 448.48 1033.41 447.04 1132.18 444.77C1134.3 444.72 1137.85 444.71 1137.85 444.71C1138.17 444.85 1138.4 445.11 1138.75 445.11C1147.05 444.34 1159.01 443.29 1166.93 440.98H1168.04C1168.04 440.98 1168.54 441.06 1168.85 440.28C1168.85 440.28 1171.78 439.34 1171.96 439.27C1171.96 439.27 1174.2 438.67 1174.78 437.96L1175.31 437.44L1175.57 437.16L1176.44 435.36C1176.44 435.36 1179.49 429.05 1181.06 420.73C1185.44 411.01 1187.79 399.25 1189.18 388.48C1189.32 387.42 1189.4 386.45 1189.47 385.58C1192.18 350.26 1194.39 284.93 1194.12 250.48C1194.12 249.9 1194.12 244.87 1194.12 243.9C1194.34 209.17 1192.14 144.88 1189.47 109.94C1189.4 109.07 1189.32 108.1 1189.18 107.04C1187.79 96.27 1185.44 84.51 1181.06 74.79C1179.49 66.47 1176.44 60.16 1176.44 60.16L1175.57 58.36L1175.31 58.08L1174.78 57.56C1174.2 56.85 1171.96 56.25 1171.96 56.25C1171.77 56.18 1168.85 55.25 1168.85 55.24C1168.54 54.46 1168.04 54.53 1168.04 54.53H1166.93C1159.01 52.23 1147.05 51.18 1138.75 50.41C1138.4 50.41 1138.16 50.67 1137.85 50.81C1137.85 50.81 1134.3 50.79 1132.18 50.75C1033.41 48.48 796.787 47.04 796.787 47.04L760.157 47.17C670.277 47.11 582.117 47.47 504.967 48.06C504.967 48.06 413.997 48.93 369.957 49.8L286.677 49.62H285.567C285.317 48.29 285.467 46.77 285.937 45.12L287.317 44.6C287.527 44.52 287.737 44.41 287.917 44.28L290.017 42.72C290.237 42.56 290.407 42.33 290.487 42.07L291.427 39.25C291.447 39.18 291.467 39.12 291.487 39.05C293.477 30.93 297.117 17.72 298.807 9.67C298.747 9.03 299.067 8.11 298.307 7.8C298.287 7.8 298.267 7.82 298.257 7.83L294.787 6.24H294.687L293.977 6.64H293.877C294.137 6.21 294.067 5.8 293.857 5.41C293.497 4.77 289.447 1 288.837 1L286.927 1.1C285.797 1.2 285.217 2 285.217 2C282.377 5.17 279.247 11.17 277.067 14.98C276.477 16.01 276.117 17.19 275.747 18.32C275.307 19.69 274.907 21.07 274.537 22.46C274.117 24.02 273.727 25.58 273.347 27.16C272.287 31.58 270.947 37.64 270.627 42.15C270.627 42.15 270.577 42.45 270.927 42.86C271.347 43.33 272.187 43.62 272.647 43.77C273.327 44.02 274.047 44.18 274.767 44.26H274.757L274.307 49.46C271.937 48.7 267.507 47.22 264.897 46.99C258.277 46.78 251.187 46.45 244.567 46.49C228.957 46.49 213.077 46.71 197.477 47.19C183.077 47.47 168.467 48.25 154.107 49.2C149.767 49.41 145.067 49.93 140.727 50.31L139.317 50.41L139.217 50.31C139.217 50.31 128.987 50.89 125.427 51.92M125.727 51.82C121.977 52.14 118.107 52.96 114.457 53.93C110.447 55.58 103.717 58.23 99.7666 60.07L99.1567 60.17L84.3667 62.39C68.9367 64.26 52.8367 68.3 41.1967 79.19C34.2867 85.82 28.9366 94.33 24.7966 102.94C18.5366 115.29 13.0266 128.84 9.79665 142.29C9.79665 142.29 9.28665 142.66 8.59665 145.01C6.68665 150.85 6.29665 162.73 5.67665 168.76C4.92665 179.16 3.89665 190.35 3.06665 200.76C1.37665 215.59 0.84665 231.5 1.03665 247.76C0.84665 264.02 1.37665 279.92 3.06665 294.76C3.89665 305.17 4.92665 316.36 5.67665 326.76C6.29665 332.79 6.68665 344.67 8.59665 350.51C9.29665 352.86 9.79665 353.23 9.79665 353.23C13.0266 366.68 18.5366 380.23 24.7966 392.58C28.9366 401.19 34.2867 409.7 41.1967 416.33C52.8367 427.23 68.9367 431.26 84.3667 433.13L99.1567 435.35L99.7666 435.45C103.717 437.29 110.447 439.94 114.457 441.59C118.107 442.57 121.977 443.39 125.727 443.7",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.69 99.1801V99.5801V99.98L1157.39 100.79L1158.81 108.23L1166.44 176.85L1168.98 245.84V245.9L1166.44 314.84L1158.81 383.46L1157.39 391",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.97 82.13C1158.97 82.13 1156.33 85.76 1157.72 91.76L1159.63 99.61V100.56C1159.63 100.56 1163.08 118.23 1165.16 134.97C1165.16 134.97 1171.77 182.94 1171.29 244.48V245.89L1171.28 251.83L1171.18 260.88L1170.78 278.9L1170.27 292.89L1169.67 306.07L1168.86 318.85L1167.95 331.12L1166.85 342.49L1165.84 352.05L1164.63 361.11L1163.42 369.77L1162.32 376.91L1161.11 383.75L1160.71 385.46L1160.41 387.28L1159.7 391",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.25 102.59L1142.42 174.94L1145.15 247.7L1142.42 320.46L1134.25 392.81",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.01 102.69L1135.16 174.96L1137.88 247.65V247.7L1135.16 320.33L1127.01 392.6",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.69 395.32L1130.25 322.41L1134.09 247.55L1130.25 172.69L1121.69 99.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M198.187 423.88C184.397 410.48 175.137 392.45 169.407 374.27C158.757 335.12 154.497 287.65 156.327 247.17C154.987 204.17 158.527 153.99 172.327 113.03C176.317 102.15 181.777 91.53 188.727 82.23C191.177 78.77 194.747 75.0801 197.687 71.9601L198.597 71.16C198.597 71.16 201.007 68.9401 201.007 68.9501C201.087 68.8101 201.117 68.73 201.107 68.55H201.007",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.137 386.85C147.737 343.19 147.107 289.8 147.107 247.78C147.107 205.76 147.737 152.37 165.137 108.71C166.447 105.98 169.697 98.94 171.287 96.43C172.617 93.53 170.527 91.23 167.427 92.44C161.967 94.28 151.847 96.38 145.607 98.67C141.777 100.08 140.647 101.27 138.437 103.97C131.257 115.76 124.987 140.4 123.767 147.74C118.167 177.11 117.957 210.61 118.247 247.78C117.957 284.95 118.167 318.45 123.767 347.82C124.987 355.16 131.257 379.8 138.437 391.59C140.637 394.29 141.777 395.48 145.607 396.89C151.847 399.19 161.967 401.29 167.427 403.12C170.527 404.33 172.627 402.04 171.287 399.13C169.687 396.62 166.447 389.58 165.137 386.85Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M149.496 247.78C149.456 205.66 149.356 132.71 177.446 88.08L147.756 96.13C144.026 97.16 140.876 98.57 138.206 101C137.176 101.94 136.356 103.08 135.736 104.33C115.386 145.51 115.576 197.16 115.576 247.77C115.576 298.39 115.386 350.05 135.736 391.22C136.356 392.47 137.176 393.62 138.206 394.55C140.876 396.98 144.026 398.39 147.756 399.42L177.446 407.47C149.356 362.84 149.456 289.89 149.496 247.77V247.78Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23609 249.12C6.37609 263.68 9.39609 314.25 10.7561 323.73C13.2861 336.11 18.6161 349.04 27.6161 358.13V358.03L27.7161 357.93H27.8161C27.9161 358.03 28.1161 358.23 28.2161 358.33L28.5161 358.23C28.5661 358.15 28.7361 357.89 28.8161 357.83C29.0961 356.77 29.0361 355.27 28.9161 354.21C28.2061 347.61 26.2261 336.64 25.4961 330.06C22.7761 310.4 21.1061 289.7 20.3661 269.88C20.0961 264.72 19.3561 247.76 19.3561 247.76C19.3561 247.76 20.0961 230.8 20.3661 225.64C21.1061 205.82 22.7861 185.12 25.4961 165.46C26.2261 158.88 28.2061 147.91 28.9161 141.31C29.0361 140.24 29.0861 138.75 28.8161 137.69C28.7361 137.64 28.5661 137.37 28.5161 137.29L28.2161 137.19C28.1161 137.29 27.9161 137.49 27.8161 137.59H27.7161L27.6161 137.49V137.39C18.6261 146.47 13.2861 159.4 10.7561 171.79C9.38609 181.27 6.36609 231.84 5.23609 246.4C5.16609 247.32 5.16609 248.21 5.23609 249.13V249.12Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M501.476 91.95H477.906V99.85H501.476V91.95Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M501.487 395.71H477.938V403.66H501.487V395.71Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M206.737 65.4399C206.707 65.5799 206.517 65.7099 206.537 65.8399C246.957 68.3899 288.777 73.2399 328.807 79.3299C328.737 80.0099 329.627 81.5499 329.817 82.7499C330.097 84.3099 328.607 86.5599 328.307 88.0799",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M215.396 199.38V199.68C215.216 200.03 214.806 200.37 214.486 200.59C213.556 200.74 208.666 201.58 207.746 201.7C207.066 201.95 206.276 201.64 205.936 201C205.846 200.47 205.816 199.73 205.836 199.18L207.426 171.7L211.396 144.46L217.706 117.67C217.796 117.31 218.066 116.68 218.416 116.46C219.406 116.13 222.566 115.84 223.646 115.65C223.956 115.6 224.366 115.73 224.646 115.85C224.716 115.96 224.816 116.22 224.846 116.35C219.386 143.45 216.906 171.79 215.386 199.37L215.396 199.38Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.117 59.1C113.487 56.41 119.817 54.05 125.427 51.96C128.987 50.93 139.217 50.35 139.217 50.35L139.317 50.45V50.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7676 60.11C103.718 58.27 110.448 55.62 114.458 53.97C118.108 52.99 121.978 52.17 125.728 51.86",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M338.246 73.69C329.226 72.59 271.826 65.86 263.496 64.03C261.496 63.55 259.286 62.65 257.456 61.72L255.746 60.71C255.506 60.63 255.196 60.53 254.926 60.47",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M251.216 60.21C229.856 58.47 220.196 57.09 200.996 68.56",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M476.518 73.69L487.298 73.66V73.69L487.598 73.8L487.798 73.99L487.898 74.19V78.83V74.19V89.09L487.798 89.39L487.598 89.69H487.298L482.568 89.7L476.628 89.59",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M796.807 47.0699L796.637 47.2499L796.537 47.5499L796.427 76.6299L795.927 78.1399L487.897 78.6499L487.997 48.6599L487.697 48.1499",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M338.967 73.6899C370.587 74.1999 444.177 73.7499 476.527 73.6899L476.627 89.5899C447.987 89.3799 418.987 88.6499 390.387 86.9699C380.147 86.2299 369.607 85.4399 359.397 84.4599C350.327 83.4699 339.237 81.8399 330.217 80.2299C330.217 80.0799 330.217 79.7799 330.217 79.6299C332.397 77.2499 335.327 75.0299 338.267 73.6899H338.967Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4863 82.4501C87.0963 82.5901 168.096 75.13 186.216 74.3",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2461 109.01C60.4861 102.67 73.8861 99.2101 86.2761 96.0301C113.946 89.2401 153.506 82.4601 181.476 76.8101C184.256 75.9101 186.636 73.79 189.216 72.48C192.796 70.51 196.966 69.21 200.996 68.55",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6172 137.39V136.89L28.3172 132.16C28.3172 132.16 28.5072 131.46 28.8172 130.6",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3162 81.54C55.1462 84.44 51.2362 88.18 47.7162 92.11C47.3962 92.49 47.0562 92.89 46.7062 93.31C44.3162 96.19 42.4062 99.06 40.9062 102.07C36.6062 111.05 32.2762 121.31 28.8262 130.65C30.8362 127.77 33.4162 125.05 35.7662 122.5C40.3562 117.39 46.9262 112.05 51.1662 106.7C60.9862 95.01 69.2862 81.12 81.9362 72.22C74.1362 74.54 66.2562 77.26 59.3162 81.54Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9258 72.22C81.9258 72.22 82.0058 72.19 82.0558 72.18L82.2558 71.98C82.1458 72.06 82.0358 72.14 81.9258 72.22Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2559 71.98C87.3259 68.79 93.1759 66.93 98.9559 65.54C131.236 61.17 222.166 56.32 253.626 56.28",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M120.506 57.8201C126.916 55.0901 134.056 52.3401 140.726 50.3501C145.066 49.9701 149.766 49.4601 154.106 49.2401C168.466 48.2901 183.086 47.5101 197.476 47.2301C213.086 46.7401 228.956 46.5301 244.566 46.5301C251.186 46.4901 258.276 46.8201 264.896 47.0301C267.886 47.3001 271.316 48.5701 274.306 49.5001",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M253.936 52.16L200.306 53.47L198.296 53.57L117.486 58L99.1664 60.21L84.3764 62.43C68.9464 64.3 52.8464 68.34 41.2064 79.23C34.2964 85.86 28.9464 94.37 24.8064 102.98C18.5464 115.33 13.0364 128.88 9.80642 142.33C9.80642 142.33 9.29642 142.7 8.60642 145.05C6.69642 150.89 6.30642 162.77 5.68642 168.8C4.93642 179.2 3.90642 190.39 3.07642 200.8C1.38642 215.63 0.856416 231.54 1.04642 247.8",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 442.98C339.837 442.64 435.957 442.55 453.417 442.25C454.927 442.22 456.417 441.99 457.837 441.48C461.537 440.17 465.057 438.03 467.027 434.56C468.057 432.73 468.917 430.54 468.877 428.41C468.547 426.9 466.707 426.34 465.357 426.1C462.597 425.35 459.437 425.32 456.597 425.09C432.547 424.85 391.617 425.21 367.637 425.09C353.487 424.85 338.407 426.23 324.367 428.21C300.467 430.96 275.187 433.67 251.207 435.35C251.507 436.16 251.637 437.89 252.917 437.26C254.207 438.95 253.017 441.49 253.727 443.3L253.927 443.4C256.487 443.28 263.127 443.18 272.037 443.1",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M269.127 53.77C270.187 54.86 270.727 55.78 271.937 55.99L291.917 57.19L289.847 54.07",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M269.127 53.7701C270.897 53.3801 272.697 52.2301 273.757 50.9501L274.167 50.2501C274.737 48.3801 274.807 46.2801 274.767 44.3101",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M291.437 39.2699C291.457 39.1999 291.477 39.1399 291.497 39.0699C293.487 30.9499 297.127 17.7399 298.817 9.68995C298.757 9.04995 299.077 8.12995 298.317 7.81995C293.007 10.5099 292.117 17.8699 290.467 23.2699C289.217 28.2199 286.477 39.1599 285.437 43.8999C285.447 44.3499 285.027 45.2699 285.737 45.2099L287.327 44.6299C287.537 44.5499 287.747 44.4399 287.927 44.3099L290.027 42.7499C290.247 42.5899 290.417 42.3599 290.497 42.0999L291.437 39.2799V39.2699Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M269.127 53.77L266.617 54.07L268.597 59.92C268.737 60.34 269.107 60.64 269.547 60.67C279.477 61.48 291.307 62.64 301.207 63.57C301.417 63.59 301.527 63.33 301.377 63.18L292.477 54.57L289.857 54.07C285.457 52.63 284.777 49.25 285.937 45.15",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M285.537 45.21C282.227 46 278.377 45.05 275.137 44.33",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M293.887 6.67003C294.147 6.24003 294.077 5.83003 293.867 5.44003C293.507 4.80003 289.457 1.03003 288.847 1.03003L286.937 1.13003C285.807 1.23003 285.227 2.03003 285.227 2.03003C282.387 5.20003 279.257 11.2 277.077 15.01C276.487 16.04 276.127 17.22 275.757 18.35C275.317 19.72 274.917 21.1 274.547 22.49C274.127 24.05 273.737 25.61 273.357 27.19C272.297 31.61 270.957 37.67 270.637 42.18C270.637 42.18 270.587 42.48 270.937 42.89C271.357 43.36 272.197 43.65 272.657 43.8C275.087 44.68 277.937 44.59 279.897 42.89C281.207 42.15 281.657 38.25 282.107 36.95C284.317 29.28 286.537 17.89 289.657 10.99C289.657 10.99 290.197 10.03 290.477 9.62003C291.247 8.49003 293.247 6.16003 293.887 6.67003Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M269.127 441.8C270.187 440.71 270.727 439.79 271.937 439.58L291.917 438.38L289.847 441.5",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M269.127 441.8C270.897 442.19 272.697 443.34 273.757 444.62L274.167 445.32C274.737 447.19 274.807 449.29 274.767 451.26",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M291.437 456.29C291.457 456.36 291.477 456.42 291.497 456.49C293.487 464.61 297.127 477.82 298.817 485.87C298.757 486.51 299.077 487.43 298.317 487.74C293.007 485.05 292.117 477.69 290.467 472.29C289.217 467.34 286.477 456.4 285.437 451.66C285.447 451.21 285.027 450.29 285.737 450.35L287.327 450.93C287.537 451.01 287.747 451.12 287.927 451.25L290.027 452.81C290.247 452.97 290.417 453.2 290.497 453.46L291.437 456.28V456.29Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M269.127 441.8L266.617 441.5L268.597 435.65C268.737 435.23 269.107 434.93 269.547 434.9C279.477 434.09 291.307 432.93 301.207 432C301.417 431.98 301.527 432.24 301.377 432.39L292.477 441L289.857 441.5C285.457 442.94 284.777 446.32 285.937 450.42",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M285.537 450.35C282.227 449.56 278.377 450.51 275.137 451.23",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M293.887 488.89C294.147 489.32 294.077 489.73 293.867 490.12C293.507 490.76 289.457 494.53 288.847 494.53L286.937 494.43C285.807 494.33 285.227 493.53 285.227 493.53C282.387 490.36 279.257 484.36 277.077 480.55C276.487 479.52 276.127 478.34 275.757 477.21C275.317 475.84 274.917 474.46 274.547 473.07C274.127 471.51 273.737 469.95 273.357 468.37C272.297 463.95 270.957 457.89 270.637 453.38C270.637 453.38 270.587 453.08 270.937 452.67C271.357 452.2 272.197 451.91 272.657 451.76C275.087 450.88 277.937 450.97 279.897 452.67C281.207 453.41 281.657 457.31 282.107 458.61C284.317 466.28 286.537 477.67 289.657 484.57C289.657 484.57 290.197 485.53 290.477 485.94C291.247 487.07 293.247 489.4 293.887 488.89Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M275.857 80.96C275.857 80.96 277.697 87.81 267.727 87.19C267.727 87.19 255.367 86.86 242.567 84.3C242.567 84.3 226.757 81.18 209.387 76.62C209.387 76.62 201.477 91.32 196.917 105.46C196.917 105.46 196.727 105.84 197.127 106.02L197.887 106.2C197.887 106.2 189.747 129.08 185.607 169.07C185.607 169.07 181.247 205.86 181.587 247.79",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M207.636 79.88H203.516C203.516 79.88 196.766 94.59 194.016 103.75C194.016 103.75 187.286 113.14 186.096 118.2C186.036 118.47 186.006 118.74 186.006 119.02L185.946 130.71L180.856 159.78L181.946 160.58L180.226 172.83C180.226 172.83 179.256 173.46 179.136 174.32C179.136 174.32 176.276 207.92 175.956 218.01L175.506 230.5C175.506 230.5 175.856 231.52 176.456 231.9L176.416 240.4",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M169.906 247.78C170.176 118.37 199.576 74.91 199.576 74.91L200.986 74.64H201.606C251.526 76.88 329.706 88.17 329.706 88.17",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M175.346 247.78V242.01L176.116 241.44L176.666 241.31V247.78H175.346Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M175.346 242.01L175.776 241.11L176.466 240.4L176.816 240.93L176.196 241.27L175.346 242.01Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M252.117 201.9C256.137 201.5 271.167 200.87 273.347 201.39C275.017 202.29 278.267 209.82 279.027 211.35C279.047 211.39 279.087 211.53 279.087 211.57C279.107 211.95 279.007 212.33 278.677 212.56C278.107 212.98 260.307 213.2 256.937 212.66C256.287 212.66 252.467 204.63 251.807 203.6C251.667 203.34 251.467 202.9 251.507 202.6C251.507 202.6 251.447 202 252.107 201.9H252.117Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M218.417 201.98C218.417 201.98 256.347 198.26 272.057 198.16C280.267 198.05 288.667 197.92 296.807 199.17C299.957 203.29 303.007 208.26 304.757 213.16C304.757 213.16 305.767 216.12 305.857 216.49V216.47C306.017 217.03 305.117 216.73 305.117 216.73C300.727 214.99 238.467 216.58 217.607 216.07C217.607 216.07 217.847 206.51 218.417 201.98ZM218.417 201.98C218.307 202.8 218.317 201.98 218.317 201.98H218.417Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M283.317 200.59C286.417 200.65 289.907 200.7 292.977 201.1C292.977 201.1 293.527 201.15 294.187 202.11C295.087 203.42 296.397 205.32 297.107 206.74C298.197 208.63 299.367 210.98 299.927 213.08C299.977 213.31 299.827 213.28 299.827 213.28C296.817 213.11 293.477 213.11 290.437 212.99C290.137 212.98 289.847 212.86 289.647 212.63C288.957 211.83 288.447 210.15 288.047 209.46C286.747 206.67 284.317 203.6 282.717 201.01C282.717 201.01 282.367 200.51 283.317 200.61V200.59Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M296.697 198.57C295.557 169.54 292.317 111.98 290.357 82.84",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M248.197 85.36C247.927 95.36 239.887 172.72 242.157 180.66C243.107 187.41 246.757 193.83 251.917 198.27C253.137 198.2 254.827 198.04 256.047 197.87C250.877 193.49 246.977 187.41 245.887 180.66C243.617 172.96 250.847 95.48 251.017 85.87L248.197 85.37V85.36Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M213.477 216.89L267.807 216.82L283.917 216.79H288.347C288.347 216.79 291.817 230.13 291.817 247.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M296.847 199.2L297.837 199.37C297.837 199.37 304.797 207.46 307.307 217.22L306.097 217.91L305.927 217.43C305.927 217.43 294.687 215.96 290.277 216.7C290.277 216.7 293.647 232.82 293.647 247.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M291.387 223.04L291.877 221.82C291.877 221.82 299.857 221.97 301.457 222.26L301.987 223.28V223.96C301.987 223.96 303.977 233.34 303.977 247.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M294.638 247.78L293.768 229.45C293.768 229.45 293.768 228.87 294.398 228.87H300.868C300.868 228.87 301.698 228.58 301.788 230.47C301.788 230.47 302.808 237.17 302.808 247.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M308.477 247.78C308.477 134.94 330.967 92.91 330.967 92.91C329.927 92.06 330.887 90.9 330.887 90.9C331.587 89.08 330.267 88.46 330.267 88.46C329.607 88.5 329.647 87.76 329.647 87.76L330.997 83.85L334.857 84.44C334.857 84.44 338.387 85.17 335.957 89.16L334.947 91.96C334.947 91.96 311.987 129.28 311.987 247.77",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M330.607 88.74L335.967 89.17",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M331.018 89.64L335.628 90.03",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M335.586 89.96C335.586 89.96 337.866 90.1 338.516 84.01C338.516 84.01 338.566 83.08 340.326 83.45C340.326 83.45 360.826 88.35 403.036 89.2L477.906 91.95",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M334.826 92.01L359.726 95.32L477.906 99.86",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M206.737 430.13C206.707 429.99 206.517 429.86 206.537 429.73C246.957 427.18 288.777 422.33 328.807 416.24C328.737 415.56 329.627 414.02 329.817 412.82C330.097 411.26 328.607 409.01 328.307 407.49",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M215.396 296.19V295.89C215.216 295.54 214.806 295.2 214.486 294.98C213.556 294.83 208.666 293.99 207.746 293.87C207.066 293.62 206.276 293.93 205.936 294.57C205.846 295.1 205.816 295.84 205.836 296.39L207.426 323.87L211.396 351.11L217.706 377.9C217.796 378.26 218.066 378.89 218.416 379.11C219.406 379.44 222.566 379.73 223.646 379.92C223.956 379.97 224.366 379.84 224.646 379.72C224.716 379.61 224.816 379.35 224.846 379.22C219.386 352.12 216.906 323.78 215.386 296.2L215.396 296.19Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M108.117 436.47C113.487 439.16 119.817 441.52 125.427 443.61C128.987 444.64 139.217 445.22 139.217 445.22L139.317 445.12V444.79",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7676 435.46C103.718 437.3 110.448 439.95 114.458 441.6C118.108 442.58 121.978 443.4 125.728 443.71",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M338.246 421.88C329.226 422.98 271.826 429.71 263.496 431.54C261.496 432.02 259.286 432.92 257.456 433.85L255.746 434.86C255.506 434.94 255.196 435.04 254.926 435.1",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M251.216 435.36C229.856 437.1 220.196 438.48 200.996 427.01",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M476.518 421.88L487.298 421.91V421.88L487.598 421.77L487.798 421.58L487.898 421.38V416.75V421.38V406.48L487.798 406.18L487.598 405.88H487.298L482.568 405.87L476.628 405.98",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M796.807 448.5L796.637 448.32L796.537 448.02L796.427 418.94L795.927 417.43L487.897 416.92L487.997 446.91L487.697 447.42",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M338.967 421.88C370.587 421.37 444.177 421.82 476.527 421.88L476.627 405.98C447.987 406.19 418.987 406.92 390.387 408.6C380.147 409.34 369.607 410.13 359.397 411.11C350.327 412.1 339.237 413.73 330.217 415.34C330.217 415.49 330.217 415.79 330.217 415.94C332.397 418.32 335.327 420.54 338.267 421.88H338.967Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4863 413.12C87.0963 412.98 168.096 420.44 186.216 421.27",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2461 386.56C60.4861 392.9 73.8861 396.36 86.2761 399.54C113.946 406.33 153.506 413.11 181.476 418.76C184.256 419.66 186.636 421.78 189.216 423.09C192.796 425.06 196.966 426.36 200.996 427.02",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6172 358.18V358.68L28.3172 363.41C28.3172 363.41 28.5072 364.11 28.8172 364.97",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3162 414.03C55.1462 411.13 51.2362 407.39 47.7162 403.46C47.3962 403.08 47.0562 402.68 46.7062 402.26C44.3162 399.38 42.4062 396.51 40.9062 393.5C36.6062 384.52 32.2762 374.26 28.8262 364.92C30.8362 367.8 33.4162 370.52 35.7662 373.07C40.3562 378.18 46.9262 383.52 51.1662 388.87C60.9862 400.56 69.2862 414.45 81.9362 423.35C74.1362 421.03 66.2562 418.31 59.3162 414.03Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9258 423.35C81.9258 423.35 82.0058 423.38 82.0558 423.39L82.2558 423.59C82.1458 423.51 82.0358 423.43 81.9258 423.35Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2559 423.59C87.3259 426.78 93.1759 428.64 98.9559 430.03C131.236 434.4 222.166 439.25 253.626 439.29",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M120.506 437.75C126.916 440.48 134.056 443.23 140.726 445.22C145.066 445.6 149.766 446.11 154.106 446.33C168.466 447.28 183.086 448.06 197.476 448.34C213.086 448.83 228.956 449.04 244.566 449.04C251.186 449.08 258.276 448.75 264.896 448.54C268.286 448.24 271.006 447.01 274.276 446.09",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M253.936 443.41L200.306 442.1L198.296 442L117.486 437.57L99.1664 435.36L84.3764 433.14C68.9464 431.27 52.8464 427.23 41.2064 416.34C34.2964 409.71 28.9464 401.2 24.8064 392.59C18.5464 380.24 13.0364 366.69 9.80642 353.24C9.80642 353.24 9.29642 352.87 8.60642 350.52C6.69642 344.68 6.30642 332.8 5.68642 326.77C4.93642 316.37 3.90642 305.18 3.07642 294.77C1.38642 279.94 0.856416 264.03 1.04642 247.77",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M275.857 414.61C275.857 414.61 277.697 407.76 267.727 408.38C267.727 408.38 255.367 408.71 242.567 411.27C242.567 411.27 226.757 414.39 209.387 418.95C209.387 418.95 201.477 404.25 196.917 390.11C196.917 390.11 196.727 389.73 197.127 389.55L197.887 389.37C197.887 389.37 189.747 366.49 185.607 326.5C185.607 326.5 181.247 289.71 181.587 247.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M207.636 415.69H203.516C203.516 415.69 196.766 400.98 194.016 391.82C194.016 391.82 187.286 382.43 186.096 377.37C186.036 377.1 186.006 376.83 186.006 376.55L185.946 364.86L180.856 335.79L181.946 334.99L180.226 322.74C180.226 322.74 179.256 322.11 179.136 321.25C179.136 321.25 176.276 287.65 175.956 277.56L175.506 265.07C175.506 265.07 175.856 264.05 176.456 263.67L176.416 255.17",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M169.906 247.79C170.176 377.2 199.576 420.66 199.576 420.66L200.986 420.93H201.606C251.526 418.69 329.706 407.4 329.706 407.4",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M175.346 247.79V253.56L176.116 254.13L176.666 254.26V247.79H175.346Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M175.346 253.56L175.776 254.46L176.466 255.17L176.816 254.64L176.196 254.3L175.346 253.56Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M252.117 293.67C256.137 294.07 271.167 294.7 273.347 294.18C275.017 293.28 278.267 285.75 279.027 284.22C279.047 284.18 279.087 284.04 279.087 284C279.107 283.62 279.007 283.24 278.677 283.01C278.107 282.59 260.307 282.37 256.937 282.91C256.287 282.91 252.467 290.94 251.807 291.97C251.667 292.23 251.467 292.67 251.507 292.97C251.507 292.97 251.447 293.57 252.107 293.67H252.117Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M218.417 293.59C218.417 293.59 256.347 297.31 272.057 297.41C280.267 297.52 288.667 297.65 296.807 296.4C299.957 292.28 303.007 287.31 304.757 282.41C304.757 282.41 305.767 279.45 305.857 279.08V279.1C306.017 278.54 305.117 278.84 305.117 278.84C300.727 280.58 238.467 278.99 217.607 279.5C217.607 279.5 217.847 289.06 218.417 293.59ZM218.417 293.59C218.307 292.77 218.317 293.59 218.317 293.59H218.417Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M283.317 294.98C286.417 294.92 289.907 294.87 292.977 294.47C292.977 294.47 293.527 294.42 294.187 293.46C295.087 292.15 296.397 290.25 297.107 288.83C298.197 286.94 299.367 284.59 299.927 282.49C299.977 282.26 299.827 282.29 299.827 282.29C296.817 282.46 293.477 282.46 290.437 282.58C290.137 282.59 289.847 282.71 289.647 282.94C288.957 283.74 288.447 285.42 288.047 286.11C286.747 288.9 284.317 291.97 282.717 294.56C282.717 294.56 282.367 295.06 283.317 294.96V294.98Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M296.697 297C295.557 326.03 292.317 383.59 290.357 412.73",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M248.197 410.21C247.927 400.21 239.887 322.85 242.157 314.91C243.107 308.16 246.757 301.74 251.917 297.3C253.137 297.37 254.827 297.53 256.047 297.7C250.877 302.08 246.977 308.16 245.887 314.91C243.617 322.61 250.847 400.09 251.017 409.7L248.197 410.2V410.21Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M213.477 278.68L267.807 278.75L283.917 278.78H288.347C288.347 278.78 291.817 265.44 291.817 247.79",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M296.847 296.37L297.837 296.2C297.837 296.2 304.797 288.11 307.307 278.35L306.097 277.66L305.927 278.14C305.927 278.14 294.687 279.61 290.277 278.87C290.277 278.87 293.647 262.75 293.647 247.79",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M291.387 272.54L291.877 273.76C291.877 273.76 299.857 273.61 301.457 273.32L301.987 272.3V271.62C301.987 271.62 303.977 262.24 303.977 247.8",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M294.638 247.79L293.768 266.12C293.768 266.12 293.768 266.7 294.398 266.7H300.868C300.868 266.7 301.698 266.99 301.788 265.1C301.788 265.1 302.808 258.4 302.808 247.79",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M308.477 247.79C308.477 360.63 330.967 402.66 330.967 402.66C329.927 403.51 330.887 404.67 330.887 404.67C331.587 406.49 330.267 407.11 330.267 407.11C329.607 407.07 329.647 407.81 329.647 407.81L330.997 411.72L334.857 411.13C334.857 411.13 338.387 410.4 335.957 406.41L334.947 403.61C334.947 403.61 311.987 366.29 311.987 247.8",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M330.607 406.83L335.967 406.4",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M331.018 405.93L335.628 405.54",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M335.586 405.61C335.586 405.61 337.866 405.47 338.516 411.56C338.516 411.56 338.566 412.49 340.326 412.12C340.326 412.12 360.826 407.22 403.036 406.37L477.906 403.62",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M334.826 403.56L359.726 400.25L477.906 395.71",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M479.346 391.42V395.83",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M367.348 296.43L367.848 296.93L367.948 297.03C374.498 304.35 379.968 308.78 388.828 312.13C389.468 312.37 390.888 312.73 390.888 312.73C393.728 313.76 397.228 314.47 400.248 314.86C413.898 315.59 441.718 316.55 455.188 317.05",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M369.357 295.52C372.357 298.74 375.537 302.4 379.237 304.86C379.397 304.97 379.527 305.08 379.527 305.08C386.737 309.88 395.337 312.77 403.997 313.11C404.227 313.11 404.517 313.14 404.627 313.15C419.567 313.69 435.817 314.22 450.767 314.85",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M372.807 299.2C373.387 298.71 376.467 297.81 377.037 297.79C378.907 297.43 383.587 297.19 383.587 297.19C393.977 296.88 404.817 298.71 414.977 300.82C419.567 301.83 424.857 303.43 429.467 304.24C432.637 304.54 435.897 305.14 439.097 305.23C439.277 305.23 439.427 305.24 439.427 305.24C440.927 305.33 442.557 305.36 444.057 305.34",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M370.868 300.15C367.418 301.96 365.648 304.86 364.928 306.09C362.878 309.24 361.238 321.99 360.398 325.72L358.988 337.69L358.378 343.73L357.978 349.67C357.668 356.41 357.558 360.4 359.448 372.84V372.8C361.128 378.29 363.228 382.58 368.608 384.82",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M443.017 302.17C440.207 302.07 437.357 301.61 434.567 301.26C423.147 298.91 409.797 295.13 398.237 293.71C390.977 293.06 381.987 292.93 374.687 293.94C374.517 293.96 372.347 294.5 371.467 294.81C369.807 295.42 367.897 296.08 366.537 296.93C364.947 297.89 362.817 299.85 362.817 299.85C358.477 303.96 357.577 311 356.577 316.65L355.167 324.3L353.957 331.95C353.657 334.5 352.887 341.06 352.657 343.52L352.257 351.27C352.207 360.86 353.437 370.97 357.187 379.85C358.637 383.12 361.047 386.07 364.227 387.8C364.227 387.8 364.937 388.21 365.727 388.64C365.937 388.75 366.147 388.85 366.367 388.93C367.857 389.48 369.427 390.12 371.017 390.54C379.287 392.56 392.027 393.01 401.867 391.92C412.307 391 424.637 388.09 435.207 387.56L437.167 387.5H440.947",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M442.306 384.63C437.066 383.93 432.096 384.16 426.856 384.47C419.866 385.13 412.276 386.95 405.146 387.56C405.146 387.56 403.666 387.71 403.086 387.77C395.976 388.45 388.516 388.65 381.476 388.1C377.876 387.65 374.116 387.44 370.816 385.89",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M472.208 304.68C472.018 305.84 471.488 310.77 471.298 312.03C471.018 313.36 470.888 313.85 470.348 314.39C469.838 314.89 469.178 315.19 468.478 315.29C463.818 315.97 458.028 316 453.388 316.16C451.588 316.07 450.318 314.42 449.258 313.34C446.268 310.03 444.048 306.38 443.018 302.17",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M469.167 387.89C468.977 386.73 468.447 381.8 468.257 380.54C467.977 379.21 467.847 378.72 467.307 378.18C466.797 377.68 466.137 377.38 465.437 377.28C460.777 376.6 454.987 376.57 450.347 376.41C448.547 376.5 447.277 378.15 446.217 379.23C443.227 382.54 441.007 386.19 439.977 390.4",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M470.797 316.84L470.187 346.44L468.777 375.93",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M468.778 375.93C468.228 375.66 454.178 374.5 453.178 374.42",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M456.307 316.15L455.197 317.06",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M453.078 376.61L454.188 346.75L455.198 317.06",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M386.668 373.61L387.668 345.64L387.768 342.82L388.878 312.13",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M431.646 372.81L432.656 344.53L433.757 316.25",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M453.198 373.61C437.718 373.29 411.068 371.55 395.478 371.83C391.888 372.3 389.758 372.7 385.968 373.71C384.428 374.32 382.758 374.75 381.238 375.42C380.258 376.07 379.138 376.65 378.118 377.23C373.648 380.39 368.808 384.15 365.338 388.4",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M367.238 389.21C376.128 381.02 377.968 377.42 390.388 374.72C393.308 374.14 396.258 373.68 399.238 373.61C415.158 374.13 432.708 374.94 448.648 375.42L450.558 375.52L453.098 375.62",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M455.197 318.32L458.177 318.16C458.177 318.16 470.657 317.23 470.777 316.85C470.777 316.85 472.797 315.31 473.157 305.31",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M494.697 316.84C494.797 307.93 493.707 307.54 493.707 307.54C486.677 301.31 461.347 297.94 461.347 297.94L451.347 297.25C441.647 297.74 442.937 302.1 442.937 302.1C442.937 302.1 444.027 297.25 460.847 301.41L470.937 304.08C470.937 304.08 481.427 307.44 480.837 316.95L480.737 347.94C480.737 347.94 480.377 381 475.987 383.75L469.157 387.91C469.157 387.91 448.477 395.73 439.967 390.68",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M455.807 297.54L468.867 300.61C468.867 300.61 477.877 302.89 481.037 307.54C481.037 307.54 483.317 309.82 483.317 317.04",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M480.547 307.04C480.547 307.04 482.927 305.95 493.707 307.53",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M439.997 390.67C439.997 390.67 439.537 394.14 445.437 394.6C445.437 394.6 454.937 396.37 472.167 389.69L476.757 386.48C476.757 386.48 479.557 384.89 480.357 380.91C480.357 380.91 481.667 375.14 481.667 372.52",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M468.617 375.94C468.617 375.94 470.007 376.24 470.007 379.21L469.987 387.39",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M477.758 385.69C477.758 385.69 485.538 386.98 491.208 385.93",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M447.287 394.85C447.287 394.85 460.627 396.02 475.717 392.38L485.997 389.65C485.997 389.65 492.177 387.89 492.177 382.95L492.957 373.52",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M501.018 354.17C500.478 366.99 498.618 369.65 498.618 369.65C497.088 373.42 493.528 373.4 493.528 373.4L483.598 373.35C481.948 373.31 480.698 371.81 480.788 370L482.498 345.3L482.418 342.21V319.63C482.418 317.98 483.758 316.64 485.408 316.64L495.358 316.84C495.358 316.84 498.938 316.91 500.268 320.38C500.268 320.38 502.518 323.6 501.668 340.13C501.668 340.13 501.088 352.35 501.008 354.17H501.018Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M480.807 369.71C480.807 369.71 484.157 369.49 486.087 361.04C486.087 361.04 487.287 356.9 487.717 349.19C487.777 348.09 488.197 340.18 488.157 339.27C487.957 333.56 487.227 328.29 487.227 328.29C485.797 319.5 482.417 319.9 482.417 319.9",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M830.446 71.08C829.896 70.93 827.846 70.72 827.116 70.18C826.376 69.73 826.106 68.86 825.986 67.91C825.866 66.96 825.656 64.55 825.646 64.2C825.576 62.38 825.756 60.44 826.116 58.71C826.346 57.59 827.016 56.49 827.016 56.49C827.016 56.49 827.376 55.76 827.926 55.49C830.656 54.96 833.676 54.92 836.546 54.9L1127.1 58.41C1124.82 60.99 1121.89 63.82 1119.35 66.16C1117.86 67.55 1115.93 69.65 1114.12 70.59C1110.4 72.25 1106.05 72.51 1102.04 72.9L1083.32 73.1L831.026 71.15L830.436 71.09L830.446 71.08Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.28 50.9501C951.557 46.4801 688.197 46.6301 496.497 48.1601C493.467 48.1801 483.887 48.1301 481.797 48.1001C443.907 47.5401 331.787 51.5801 285.797 50.4601",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M830.356 71.14L796.426 70.87",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.81 91.92H501.486V99.87H1126.81V91.92Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M1131.44 77.82L1131.13 77.21L1130.83 77.11L1125.09 76.92L1115.94 76.61L1106.68 76.41L1097.42 76.21L1088.16 76.11L1069.75 75.91L1052.34 75.7L796.438 73.89",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M1175.01 246.78V247.68V247.78L1175.11 247.99L1175.41 248.08H1177.12H1178.53L1178.73 248.18L1178.93 248.29V248.8",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M1192.21 246.77V247.78V248.08L1192.32 248.29L1192.56 248.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.44 113.64L1165.54 120.29L1167.06 129.64L1168.26 138.6L1169.47 147.86L1170.07 153.99L1170.68 160.23L1171.79 172.71L1172.29 179.66L1172.79 186.7L1173.5 200.08L1173.9 211.25L1174.1 219.1L1174.3 227.05L1174.5 238.32V246.07V246.27L1174.6 246.57L1174.7 246.78H1174.8H1194.13",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M1177.73 102.78L1177.83 102.98",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.99 87.8199L1177.83 102.98",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.29 246.78C1188.42 243.08 1186.95 206.08 1188.59 203.71C1188.65 199.33 1188.53 194.8 1188.39 190.43C1187.34 169.12 1185.49 147.07 1182.55 125.93C1181.79 120.54 1180.89 114.73 1179.73 109.43C1179.18 107.35 1178.93 104.84 1177.82 102.99L1177.72 102.79C1177.58 102.68 1177.29 102.52 1177.11 102.49C1175.35 104.08 1173.49 106.17 1171.78 107.82C1170.6 109.15 1168.74 110.63 1168.66 112.55",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.84 110.42L1163.24 106.9V106.6L1163.03 102.56",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.84 110.42L1164.44 113.64",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M1181.04 74.7C1185.45 84.44 1187.81 96.26 1189.21 107.06C1189.35 108.12 1189.43 109.09 1189.5 109.96C1192.25 145.88 1194.49 212.81 1194.13 246.77",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.9 53.78L1140.29 53.87C1149.53 54.47 1159.95 56.24 1168.89 58.77L1171.01 59.27L1174.81 57.59",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.96 54.5699C1159.04 52.2699 1147.08 51.2099 1138.78 50.4399C1138.43 50.4399 1138.19 50.6999 1137.88 50.8399",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.43 55.24L1168.07 54.56C1168.07 54.56 1168.7 54.46 1168.98 55.58L1169.61 58.66L1157.52 55.5C1157.52 55.5 1157.29 55.4 1157.44 55.24H1157.43Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.87 55.28C1168.87 55.28 1171.8 56.22 1171.98 56.29C1171.98 56.29 1174.22 56.89 1174.8 57.6L1175.33 58.12L1175.28 58.28L1171.18 59.93",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.36 50.96L1139.57 51.31L1139.99 54.66L1137.78 61.41L1130.62 77.11",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M1171 59.27L1171.18 59.92L1171.49 61.96",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.21 61.22L1156.96 82.05C1156.96 82.05 1154.39 85.7 1155.23 91.93L1157.1 101.01H1133.04L1131.4 90.9L1129.43 90.53C1130.41 79.25 1131.54 77.52 1131.54 77.52L1138.84 61.79L1140.99 54.96L1146.09 55.47L1154.33 56.64L1160.42 57.95L1168.61 60.52C1168.61 60.52 1171.47 60.85 1173.24 64.87C1173.24 64.87 1175.54 69.66 1176.54 74.44C1176.54 74.44 1176.66 74.99 1176.4 75.34L1172.3 80.19",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M1129.43 90.53C1129.43 90.53 1129.38 91.33 1128.96 91.28V92.73",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.86 92.74H1129.22C1129.22 92.74 1129.3 101.3 1128.64 102.61",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.91 71.1801L1158.97 84.0201C1159.24 82.7201 1155.32 81.26 1152.4 80.37C1150.74 79.86 1149.05 79.4701 1147.34 79.1701L1143 78.4001L1131.67 77.3201",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.25 69.2599C1171.07 73.1499 1172.22 79.9899 1172.22 79.9899C1172.25 80.9899 1170.61 81.1199 1170.61 81.1199C1169.05 74.2899 1166.54 70.4599 1166.54 70.4599L1166.28 67.8199C1166.28 67.8199 1166.97 67.4399 1168.02 68.9499L1168.25 69.2599Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M1172.34 63.22L1168.3 69.21",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.6 81.12L1170.74 81.64L1163.21 92.43L1162.68 95.69L1163.29 94.31L1164.22 93.09L1171.49 82.67L1176.71 76.47C1176.71 76.47 1177.13 76.13 1177.27 77.05L1177.77 79.01L1180 78.43C1180 78.43 1181.64 78.09 1181.37 76.35C1179.92 67.28 1176.48 60.19 1176.48 60.19L1175.61 58.39L1175.35 58.11",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.66 83.89C1170.66 83.89 1171.13 83.69 1171.24 84.26L1172.3 88.42C1172.3 88.42 1172.43 89.14 1172.64 89.03L1173.81 87.55C1173.81 87.55 1173.94 87.33 1173.76 86.75L1172.65 81.98C1172.65 81.98 1172.62 81.71 1172.25 81.79",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M1180.58 78.11L1180.26 80.39C1180.26 80.39 1180.05 81.08 1179.2 82.14L1167.69 97.63C1167.69 97.63 1166.45 98.63 1167.35 105.63",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.71 92.4399L1168.75 112.8L1173.1 148.97L1176.87 181.21L1178.78 246.77",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.45 81.61L1162.05 84.23",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M1163 86.2L1164.33 90.6199V90.79",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M1162.68 95.6899L1163.03 102.56",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.03 102.56L1126.99 102.64",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M830.446 424.49C829.896 424.64 827.846 424.85 827.116 425.39C826.376 425.84 826.106 426.71 825.986 427.66C825.866 428.61 825.656 431.02 825.646 431.37C825.576 433.19 825.756 435.13 826.116 436.86C826.346 437.98 827.016 439.08 827.016 439.08C827.016 439.08 827.376 439.81 827.926 440.08C830.656 440.61 833.676 440.65 836.546 440.67L1127.1 437.16C1124.82 434.58 1121.89 431.75 1119.35 429.41C1117.86 428.02 1115.93 425.92 1114.12 424.98C1110.4 423.32 1106.05 423.06 1102.04 422.67L1083.32 422.47L831.026 424.42L830.436 424.48L830.446 424.49Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.28 444.62C951.557 449.09 688.197 448.94 496.497 447.41C493.467 447.39 483.887 447.44 481.797 447.47C443.907 448.03 331.787 443.99 285.797 445.11",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M830.356 424.43L796.426 424.7",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.81 395.7H501.486V403.65H1126.81V395.7Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M1131.44 417.75L1131.13 418.36L1130.83 418.46L1125.09 418.65L1115.94 418.96L1106.68 419.16L1097.42 419.36L1088.16 419.46L1069.75 419.66L1052.34 419.87L796.438 421.68",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.44 381.93L1165.54 375.28L1167.06 365.93L1168.26 356.97L1169.47 347.71L1170.07 341.58L1170.68 335.34L1171.79 322.86L1172.29 315.91L1172.79 308.87L1173.5 295.49L1173.9 284.32L1174.1 276.47L1174.3 268.52L1174.5 257.25V249.5V249.3L1174.6 249L1174.7 248.79L1174.8 248.8H1194.13",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M1177.73 392.79L1177.83 392.59",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.99 407.75L1177.83 392.59",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.29 248.8C1188.42 252.5 1186.95 289.5 1188.59 291.87C1188.65 296.25 1188.53 300.78 1188.39 305.15C1187.34 326.46 1185.49 348.51 1182.55 369.65C1181.79 375.04 1180.89 380.85 1179.73 386.15C1179.18 388.23 1178.93 390.74 1177.82 392.59L1177.72 392.79C1177.58 392.9 1177.29 393.06 1177.11 393.09C1175.35 391.5 1173.49 389.41 1171.78 387.76C1170.6 386.43 1168.74 384.95 1168.66 383.03",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.84 385.15L1163.24 388.67V388.97L1163.03 393.01",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.84 385.15L1164.44 381.93",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M1181.04 420.87C1185.45 411.13 1187.81 399.31 1189.21 388.51C1189.35 387.45 1189.43 386.48 1189.5 385.61C1192.25 349.69 1194.49 282.76 1194.13 248.8",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.9 441.8L1140.29 441.71C1149.53 441.11 1159.95 439.34 1168.89 436.81L1171.01 436.31L1174.81 437.99",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.96 441C1159.04 443.3 1147.08 444.36 1138.78 445.13C1138.43 445.13 1138.19 444.87 1137.88 444.73",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.43 440.33L1168.07 441.01C1168.07 441.01 1168.7 441.11 1168.98 439.99L1169.61 436.91L1157.52 440.07C1157.52 440.07 1157.29 440.17 1157.44 440.33H1157.43Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.87 440.29C1168.87 440.29 1171.8 439.35 1171.98 439.28C1171.98 439.28 1174.22 438.68 1174.8 437.97L1175.33 437.45L1175.28 437.29L1171.18 435.64",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.36 444.61L1139.57 444.26L1139.99 440.91L1137.78 434.16L1130.62 418.46",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M1171 436.3L1171.18 435.65L1171.49 433.61",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.21 434.35L1156.96 413.52C1156.96 413.52 1154.39 409.87 1155.23 403.64L1157.1 394.56H1133.04L1131.4 404.67L1129.43 405.04C1130.41 416.32 1131.54 418.05 1131.54 418.05L1138.84 433.78L1140.99 440.61L1146.09 440.1L1154.33 438.93L1160.42 437.62L1168.61 435.05C1168.61 435.05 1171.47 434.72 1173.24 430.7C1173.24 430.7 1175.54 425.91 1176.54 421.13C1176.54 421.13 1176.66 420.58 1176.4 420.23L1172.3 415.38",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M1129.43 405.04C1129.43 405.04 1129.38 404.24 1128.96 404.29V402.84",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.86 402.83H1129.22C1129.22 402.83 1129.3 394.27 1128.64 392.96",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.91 424.39L1158.97 411.55C1159.24 412.85 1155.32 414.31 1152.4 415.2C1150.74 415.71 1149.05 416.1 1147.34 416.4L1143 417.17L1131.67 418.25",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.25 426.31C1171.07 422.42 1172.22 415.58 1172.22 415.58C1172.25 414.58 1170.61 414.45 1170.61 414.45C1169.05 421.28 1166.54 425.11 1166.54 425.11L1166.28 427.75C1166.28 427.75 1166.97 428.13 1168.02 426.62L1168.25 426.31Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M1172.34 432.35L1168.3 426.36",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.6 414.45L1170.74 413.93L1163.21 403.14L1162.68 399.88L1163.29 401.26L1164.22 402.48L1171.49 412.9L1176.71 419.1C1176.71 419.1 1177.13 419.44 1177.27 418.52L1177.77 416.56L1180 417.14C1180 417.14 1181.64 417.48 1181.37 419.22C1179.92 428.29 1176.48 435.38 1176.48 435.38L1175.61 437.18L1175.35 437.46",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.66 411.68C1170.66 411.68 1171.13 411.88 1171.24 411.31L1172.3 407.15C1172.3 407.15 1172.43 406.43 1172.64 406.54L1173.81 408.02C1173.81 408.02 1173.94 408.24 1173.76 408.82L1172.65 413.59C1172.65 413.59 1172.62 413.86 1172.25 413.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M1180.58 417.46L1180.26 415.18C1180.26 415.18 1180.05 414.49 1179.2 413.43L1167.69 397.94C1167.69 397.94 1166.45 396.94 1167.35 389.94",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.71 403.13L1168.75 382.77L1173.1 346.6L1176.87 314.36L1178.78 248.8",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.45 413.96L1162.05 411.34",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M1163 409.37L1164.33 404.95V404.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M1162.68 399.88L1163.03 393.01",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.03 393.01L1126.99 392.93",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M125.427 443.61C128.987 444.64 139.217 445.22 139.217 445.22L139.317 445.12L140.727 445.22C145.067 445.6 149.767 446.11 154.107 446.33C168.467 447.28 183.087 448.06 197.477 448.34C213.087 448.83 228.957 449.04 244.567 449.04C251.187 449.08 258.277 448.75 264.897 448.54C267.507 448.31 271.907 446.86 274.277 446.09L274.757 451.25H274.767C274.047 451.34 273.327 451.5 272.647 451.75C272.187 451.9 271.357 452.18 270.927 452.66C270.577 453.07 270.627 453.37 270.627 453.37C270.937 457.88 272.287 463.94 273.347 468.36C273.727 469.93 274.117 471.5 274.537 473.06C274.917 474.45 275.307 475.83 275.747 477.2C276.117 478.33 276.477 479.51 277.067 480.54C279.247 484.36 282.377 490.36 285.217 493.52C285.217 493.52 285.797 494.32 286.927 494.42L288.837 494.52C289.447 494.52 293.497 490.75 293.857 490.11C294.067 489.72 294.137 489.31 293.877 488.88H293.977L294.687 489.28H294.787L298.257 487.69C298.257 487.69 298.297 487.71 298.307 487.72C299.067 487.42 298.747 486.49 298.807 485.85C297.127 477.79 293.477 464.59 291.487 456.47C291.467 456.4 291.447 456.34 291.427 456.27L290.487 453.45C290.397 453.19 290.237 452.96 290.017 452.8L287.917 451.24C287.737 451.1 287.527 450.99 287.317 450.92L285.937 450.41C285.467 448.76 285.317 447.24 285.567 445.9H286.677L369.957 445.72C414.007 446.58 504.967 447.46 504.967 447.46C582.117 448.05 670.277 448.42 760.157 448.35L796.787 448.48C796.787 448.48 1033.41 447.04 1132.18 444.77C1134.3 444.72 1137.85 444.71 1137.85 444.71C1138.17 444.85 1138.4 445.11 1138.75 445.11C1147.05 444.34 1159.01 443.29 1166.93 440.98H1168.04C1168.04 440.98 1168.54 441.06 1168.85 440.28C1168.85 440.28 1171.78 439.34 1171.96 439.27C1171.96 439.27 1174.2 438.67 1174.78 437.96L1175.31 437.44L1175.57 437.16L1176.44 435.36C1176.44 435.36 1179.49 429.05 1181.06 420.73C1185.44 411.01 1187.79 399.25 1189.18 388.48C1189.32 387.42 1189.4 386.45 1189.47 385.58C1192.18 350.26 1194.39 284.93 1194.12 250.48C1194.12 249.9 1194.12 244.87 1194.12 243.9C1194.34 209.17 1192.14 144.88 1189.47 109.94C1189.4 109.07 1189.32 108.1 1189.18 107.04C1187.79 96.27 1185.44 84.51 1181.06 74.79C1179.49 66.47 1176.44 60.16 1176.44 60.16L1175.57 58.36L1175.31 58.08L1174.78 57.56C1174.2 56.85 1171.96 56.25 1171.96 56.25C1171.77 56.18 1168.85 55.25 1168.85 55.24C1168.54 54.46 1168.04 54.53 1168.04 54.53H1166.93C1159.01 52.23 1147.05 51.18 1138.75 50.41C1138.4 50.41 1138.16 50.67 1137.85 50.81C1137.85 50.81 1134.3 50.79 1132.18 50.75C1033.41 48.48 796.787 47.04 796.787 47.04L760.157 47.17C670.277 47.11 582.117 47.47 504.967 48.06C504.967 48.06 413.997 48.93 369.957 49.8L286.677 49.62H285.567C285.317 48.29 285.467 46.77 285.937 45.12L287.317 44.6C287.527 44.52 287.737 44.41 287.917 44.28L290.017 42.72C290.237 42.56 290.407 42.33 290.487 42.07L291.427 39.25C291.447 39.18 291.467 39.12 291.487 39.05C293.477 30.93 297.117 17.72 298.807 9.67C298.747 9.03 299.067 8.11 298.307 7.8C298.287 7.8 298.267 7.82 298.257 7.83L294.787 6.24H294.687L293.977 6.64H293.877C294.137 6.21 294.067 5.8 293.857 5.41C293.497 4.77 289.447 1 288.837 1L286.927 1.1C285.797 1.2 285.217 2 285.217 2C282.377 5.17 279.247 11.17 277.067 14.98C276.477 16.01 276.117 17.19 275.747 18.32C275.307 19.69 274.907 21.07 274.537 22.46C274.117 24.02 273.727 25.58 273.347 27.16C272.287 31.58 270.947 37.64 270.627 42.15C270.627 42.15 270.577 42.45 270.927 42.86C271.347 43.33 272.187 43.62 272.647 43.77C273.327 44.02 274.047 44.18 274.767 44.26H274.757L274.307 49.46C271.937 48.7 267.507 47.22 264.897 46.99C258.277 46.78 251.187 46.45 244.567 46.49C228.957 46.49 213.077 46.71 197.477 47.19C183.077 47.47 168.467 48.25 154.107 49.2C149.767 49.41 145.067 49.93 140.727 50.31L139.317 50.41L139.217 50.31C139.217 50.31 128.987 50.89 125.427 51.92M125.727 51.82C121.977 52.14 118.107 52.96 114.457 53.93C110.447 55.58 103.717 58.23 99.7666 60.07L99.1567 60.17L84.3667 62.39C68.9367 64.26 52.8367 68.3 41.1967 79.19C34.2867 85.82 28.9366 94.33 24.7966 102.94C18.5366 115.29 13.0266 128.84 9.79665 142.29C9.79665 142.29 9.28665 142.66 8.59665 145.01C6.68665 150.85 6.29665 162.73 5.67665 168.76C4.92665 179.16 3.89665 190.35 3.06665 200.76C1.37665 215.59 0.84665 231.5 1.03665 247.76C0.84665 264.02 1.37665 279.92 3.06665 294.76C3.89665 305.17 4.92665 316.36 5.67665 326.76C6.29665 332.79 6.68665 344.67 8.59665 350.51C9.29665 352.86 9.79665 353.23 9.79665 353.23C13.0266 366.68 18.5366 380.23 24.7966 392.58C28.9366 401.19 34.2867 409.7 41.1967 416.33C52.8367 427.23 68.9367 431.26 84.3667 433.13L99.1567 435.35L99.7666 435.45C103.717 437.29 110.447 439.94 114.457 441.59C118.107 442.57 121.977 443.39 125.727 443.7",
    stroke: "#26231E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M478.885 48.73V91.95",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M330.096 79.63V50.25",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M515.066 396.02C515.066 396.02 516.936 393.55 529.086 393.55C541.236 393.55 588.016 393.55 588.016 393.55C588.016 393.55 595.326 393.52 599.816 395.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M937.397 99.73H716.617V181.81H937.397V99.73Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M937.397 99.73H716.617V181.81H937.397V99.73Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M909.037 297.08H814.757C814.37 297.08 814.057 297.393 814.057 297.78V299.15C814.057 299.537 814.37 299.85 814.757 299.85H909.037C909.423 299.85 909.737 299.537 909.737 299.15V297.78C909.737 297.393 909.423 297.08 909.037 297.08Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M926.546 135.23H853.646V180.83H926.546V135.23Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M926.546 135.23H853.646V180.83H926.546V135.23Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M597.596 253.81H543.266C539.759 253.81 536.916 256.653 536.916 260.16V389.27C536.916 392.777 539.759 395.62 543.266 395.62H597.596C601.103 395.62 603.946 392.777 603.946 389.27V260.16C603.946 256.653 601.103 253.81 597.596 253.81Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M701.786 254.79H615.146C613.589 254.79 612.326 256.052 612.326 257.61V390.89C612.326 392.447 613.589 393.71 615.146 393.71H701.786C703.344 393.71 704.606 392.447 704.606 390.89V257.61C704.606 256.052 703.344 254.79 701.786 254.79Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M614.217 256.01C614.217 256.01 616.197 259.04 616.197 278.74V374.27C616.197 374.27 616.217 386.12 614.407 393.4",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M701.955 392.35C701.955 392.35 698.865 389.32 698.865 369.62V274.09C698.865 274.09 698.825 262.24 701.665 254.96",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M701.407 255.69C701.407 255.69 699.477 258.96 686.977 258.96C674.477 258.96 626.347 258.96 626.347 258.96C626.347 258.96 618.827 259 614.207 256",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M616.096 392.53C616.096 392.53 617.966 390.06 630.116 390.06C642.266 390.06 689.046 390.06 689.046 390.06C689.046 390.06 696.356 390.03 700.846 392.29",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M615.195 392.53C615.195 392.53 639.405 355.94 658.465 350.15",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M701.945 393.41C701.945 393.41 677.225 356.07 657.775 350.15",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M697.756 317.81C697.756 317.81 675.606 344.9 658.166 349.19",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M616.096 317.81C616.096 317.81 639.446 344.9 657.816 349.19",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M657.366 352.93C658.901 352.93 660.146 351.685 660.146 350.15C660.146 348.615 658.901 347.37 657.366 347.37C655.831 347.37 654.586 348.615 654.586 350.15C654.586 351.685 655.831 352.93 657.366 352.93Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M657.996 292.71C639.546 296.14 616.096 317.81 616.096 317.81",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M697.586 317.81C697.586 317.81 675.626 296.14 658.336 292.71",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M701.406 255.69C701.406 255.69 677.486 287.64 658.656 292.7",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M614.217 255.69C614.217 255.69 638.367 287.64 657.367 292.7",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M657.366 295.49C658.901 295.49 660.146 294.245 660.146 292.71C660.146 291.175 658.901 289.93 657.366 289.93C655.831 289.93 654.586 291.175 654.586 292.71C654.586 294.245 655.831 295.49 657.366 295.49Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M618.967 186.72C618.967 186.72 641.157 151.74 658.627 146.2",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M701.406 184.77C701.406 184.77 677.666 151.47 658.986 146.2",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M700.537 104.31C700.537 104.31 677.457 140.47 659.297 146.2",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M618.967 105.7C618.967 105.7 641.327 140.66 658.917 146.2",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M659.036 148.98C660.571 148.98 661.816 147.735 661.816 146.2C661.816 144.665 660.571 143.42 659.036 143.42C657.5 143.42 656.256 144.665 656.256 146.2C656.256 147.735 657.5 148.98 659.036 148.98Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M704.036 101.7H616.236C614.999 101.7 613.996 102.703 613.996 103.94V187.17C613.996 188.407 614.999 189.41 616.236 189.41H704.036C705.273 189.41 706.276 188.407 706.276 187.17V103.94C706.276 102.703 705.273 101.7 704.036 101.7Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M618.867 185.07L618.887 106.03C618.887 105.34 619.777 104.78 620.867 104.78H699.427C700.517 104.79 701.407 105.35 701.407 106.04L701.387 185.06C701.387 185.75 700.497 186.31 699.407 186.31H620.847C619.757 186.31 618.867 185.75 618.867 185.06V185.07Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M937.396 280.55H718.756V395.75H937.396V280.55Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M937.396 280.55H718.756V395.75H937.396V280.55Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M1020.77 181.8H939.977V279.46H1020.77V181.8Z",
    fill: "#C9C9C9"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M939.977 99.6V393.99H1120.85V99.6H939.977Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M939.977 99.6V393.99H1120.85V99.6H939.977Z",
    fill: "#C9C9C9"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.77 181.8H939.977V279.46H1020.77V181.8Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M745.327 108.88H826.877C839.207 108.88 849.217 118.89 849.217 131.22V162.97C849.217 168.28 844.907 172.59 839.597 172.59H745.337C740.027 172.59 735.717 168.28 735.717 162.97V118.5C735.717 113.19 740.027 108.88 745.337 108.88H745.327Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M931.896 102.33H723.066C721.47 102.33 720.176 103.624 720.176 105.22V175.2C720.176 176.796 721.47 178.09 723.066 178.09H931.896C933.492 178.09 934.786 176.796 934.786 175.2V105.22C934.786 103.624 933.492 102.33 931.896 102.33Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M792.456 146.3C795.378 146.3 797.746 143.824 797.746 140.77C797.746 137.716 795.378 135.24 792.456 135.24C789.534 135.24 787.166 137.716 787.166 140.77C787.166 143.824 789.534 146.3 792.456 146.3Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M792.457 145.49C794.948 145.49 796.967 143.377 796.967 140.77C796.967 138.163 794.948 136.05 792.457 136.05C789.966 136.05 787.947 138.163 787.947 140.77C787.947 143.377 789.966 145.49 792.457 145.49Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M842.433 112.645L840.39 110.602C839.839 110.051 838.946 110.051 838.396 110.602L811.115 137.882C810.565 138.432 810.565 139.325 811.115 139.876L813.159 141.919C813.71 142.47 814.602 142.47 815.153 141.919L842.433 114.639C842.984 114.089 842.984 113.196 842.433 112.645Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M838.336 117.81C841.059 117.81 843.266 115.791 843.266 113.3C843.266 110.809 841.059 108.79 838.336 108.79C835.614 108.79 833.406 110.809 833.406 113.3C833.406 115.791 835.614 117.81 838.336 117.81Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M834.976 110.01C834.976 110.01 833.566 111.08 826.016 113.31C822.536 116.76 827.566 118.1 827.566 118.1C827.566 118.1 833.406 117.14 838.336 117.82",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M834.976 110.01C834.976 110.01 833.566 111.08 826.016 113.31C822.536 116.76 827.566 118.1 827.566 118.1C827.566 118.1 833.406 117.14 838.336 117.82",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M706.646 104.89V186.2C706.646 187.97 705.206 189.41 703.436 189.41H692.696C688.386 189.41 684.896 185.91 684.896 181.61V108.72C684.896 104.84 688.046 101.7 691.916 101.7H703.446C705.216 101.7 706.656 103.14 706.656 104.91L706.646 104.89Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M706.646 257.94V392.18C706.646 394.2 705.007 395.85 702.977 395.85H693.806C688.876 395.85 684.887 391.85 684.887 386.93V262.32C684.887 257.89 688.487 254.29 692.917 254.29H702.977C704.997 254.29 706.646 255.93 706.646 257.96V257.94Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M711.697 100.42H520.967V396.88H711.697V100.42Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M711.697 100.42H520.967V396.88H711.697V100.42Z",
    fill: "#C9C9C9"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M931.926 284.71H723.986V392.82H931.926V284.71Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M939.097 181.8H934.787V279.46H939.097V181.8Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M766.247 334.77C766.247 348.06 766.557 359.97 763.137 358.84C754.467 355.98 753.057 348.03 753.057 334.73C753.057 321.43 754.847 314.69 763.137 310.69C766.547 309.05 766.247 321.47 766.247 334.76V334.77Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M767.696 359.79C767.696 359.79 786.986 367.07 800.346 369.12C818.826 371.95 796.586 387.19 781.466 386.92C765.786 386.64 758.316 386.25 758.746 373.49C759.126 362.27 767.696 359.79 767.696 359.79Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M783.957 370.2C783.957 370.2 773.727 370.14 769.177 362.58C768.437 361.36 766.627 361.24 765.287 362.35C764.137 363.31 763.237 364.68 763.697 366.5C766.117 376.07 779.937 373.41 783.167 372.81C783.167 372.81 788.247 371.14 783.957 370.2Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M785.667 340.56C790.196 340.56 793.867 336.889 793.867 332.36C793.867 327.831 790.196 324.16 785.667 324.16C781.138 324.16 777.467 327.831 777.467 332.36C777.467 336.889 781.138 340.56 785.667 340.56Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M795.185 378.89C797.025 378.89 798.516 377.399 798.516 375.56C798.516 373.721 797.025 372.23 795.185 372.23C793.346 372.23 791.855 373.721 791.855 375.56C791.855 377.399 793.346 378.89 795.185 378.89Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M953.776 98.97H498.736V153.54H953.776V98.97Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M909.116 305.44H829.286C828.944 305.44 828.666 305.718 828.666 306.06V307.37C828.666 307.712 828.944 307.99 829.286 307.99H909.116C909.458 307.99 909.736 307.712 909.736 307.37V306.06C909.736 305.718 909.458 305.44 909.116 305.44Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M909.127 313.8H836.977C836.64 313.8 836.367 314.073 836.367 314.41V315.96C836.367 316.297 836.64 316.57 836.977 316.57H909.127C909.464 316.57 909.737 316.297 909.737 315.96V314.41C909.737 314.073 909.464 313.8 909.127 313.8Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M908.996 322.15H803.426C803.017 322.15 802.686 322.481 802.686 322.89V324.18C802.686 324.589 803.017 324.92 803.426 324.92H908.996C909.404 324.92 909.736 324.589 909.736 324.18V322.89C909.736 322.481 909.404 322.15 908.996 322.15Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M908.996 330.51H803.426C803.017 330.51 802.686 330.841 802.686 331.25V332.54C802.686 332.949 803.017 333.28 803.426 333.28H908.996C909.404 333.28 909.736 332.949 909.736 332.54V331.25C909.736 330.841 909.404 330.51 908.996 330.51Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M908.996 338.87H803.426C803.017 338.87 802.686 339.201 802.686 339.61V340.9C802.686 341.309 803.017 341.64 803.426 341.64H908.996C909.404 341.64 909.736 341.309 909.736 340.9V339.61C909.736 339.201 909.404 338.87 908.996 338.87Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M908.996 347.22H803.426C803.017 347.22 802.686 347.551 802.686 347.96V349.25C802.686 349.659 803.017 349.99 803.426 349.99H908.996C909.404 349.99 909.736 349.659 909.736 349.25V347.96C909.736 347.551 909.404 347.22 908.996 347.22Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M908.996 355.58H803.426C803.017 355.58 802.686 355.911 802.686 356.32V357.61C802.686 358.019 803.017 358.35 803.426 358.35H908.996C909.404 358.35 909.736 358.019 909.736 357.61V356.32C909.736 355.911 909.404 355.58 908.996 355.58Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M909.046 363.94H818.366C817.985 363.94 817.676 364.249 817.676 364.63V366.02C817.676 366.401 817.985 366.71 818.366 366.71H909.046C909.427 366.71 909.736 366.401 909.736 366.02V364.63C909.736 364.249 909.427 363.94 909.046 363.94Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M909.027 372.29H813.517C813.125 372.29 812.807 372.608 812.807 373V374.35C812.807 374.742 813.125 375.06 813.517 375.06H909.027C909.419 375.06 909.737 374.742 909.737 374.35V373C909.737 372.608 909.419 372.29 909.027 372.29Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M909.686 380.65H809.286C808.889 380.65 808.566 380.972 808.566 381.37V382.7C808.566 383.098 808.889 383.42 809.286 383.42H909.686C910.084 383.42 910.406 383.098 910.406 382.7V381.37C910.406 380.972 910.084 380.65 909.686 380.65Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M803.306 294.37C805.116 290.91 807.566 289.59 810.956 289.59H905.236C915.016 289.59 922.946 300.26 922.946 313.42V377.4C922.946 384.84 918.466 390.88 912.926 390.88H810.946C807.876 390.88 804.546 388.54 802.676 385.07",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M680.256 341.85H513.186V396.42H680.256V341.85Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M680.256 341.85H513.186V396.42H680.256V341.85Z",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M814.266 362.13C814.266 362.13 810.426 392.82 776.916 392.82H724.686V284.71H781.906C781.906 284.71 811.876 291.69 814.276 314.14L816.566 335.58L814.276 362.12L814.266 362.13Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M780.747 362.26C783.647 362.98 790.227 365.38 798.397 365.84C820.007 367.05 839.367 350.82 839.367 332.36C839.367 313.9 821.827 298.95 800.197 298.95C794.737 298.95 789.637 300.32 784.807 301.63C774.877 304.31 766.377 312.59 766.377 312.59C763.227 316.26 761.027 324.77 761.027 334.68C761.027 341.03 761.937 346.81 763.407 351.1C764.337 353.79 766.147 355.94 768.477 357.13C772.017 358.93 777.827 361.54 780.747 362.26Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M800.287 356.74C816.342 356.74 829.357 345.825 829.357 332.36C829.357 318.895 816.342 307.98 800.287 307.98C784.232 307.98 771.217 318.895 771.217 332.36C771.217 345.825 784.232 356.74 800.287 356.74Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M953.776 98.97H498.736V153.54H953.776V98.97Z",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M377.787 99.05H311.577C309.583 99.05 307.967 100.666 307.967 102.66V204.3C307.967 206.294 309.583 207.91 311.577 207.91H377.787C379.781 207.91 381.397 206.294 381.397 204.3V102.66C381.397 100.666 379.781 99.05 377.787 99.05Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M377.787 99.05H311.577C309.583 99.05 307.967 100.666 307.967 102.66V204.3C307.967 206.294 309.583 207.91 311.577 207.91H377.787C379.781 207.91 381.397 206.294 381.397 204.3V102.66C381.397 100.666 379.781 99.05 377.787 99.05Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M377.637 108.13H311.717C310.469 108.13 309.457 109.142 309.457 110.39V150.14C309.457 151.388 310.469 152.4 311.717 152.4H377.637C378.885 152.4 379.897 151.388 379.897 150.14V110.39C379.897 109.142 378.885 108.13 377.637 108.13Z",
    fill: "white",
    stroke: "#25221E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M377.637 154.85H311.717C310.469 154.85 309.457 155.862 309.457 157.11V196.86C309.457 198.108 310.469 199.12 311.717 199.12H377.637C378.885 199.12 379.897 198.108 379.897 196.86V157.11C379.897 155.862 378.885 154.85 377.637 154.85Z",
    fill: "white",
    stroke: "#25221E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M380.106 122.4H372.146V138.74H380.106V122.4Z",
    fill: "white",
    stroke: "#25221E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M380.106 168.81H372.146V185.15H380.106V168.81Z",
    fill: "white",
    stroke: "#25221E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarBayrun4);
export default __webpack_public_path__ + "static/media/car_bayrun4.8c957fc89822b4922d58a4523ac4376f.svg";
export { ForwardRef as ReactComponent };